<template>
  <site-modal
    ID="drChavoshiNotAllowedModal"
    @closed="closedrChavoshiNotAllowedModal"
  >
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-info-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          ></path>
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>
        توجه
      </h6>
    </template>
    <template #body>
      <div>
        <p class="justified">
          مراجع گرامی، در حال حاضر امکان دریافت نوبت از این درمانگر فراهم نیست.
          با این‌ حال، می‌توانید از سایر متخصصان کلینیک ارگانیک مایندد وقت
          بگیرید. تمامی درمانگران ما تحت نظارت و آموزش مستقیم ایشان فعالیت
          می‌کنند، بنابراین می‌توانید با اطمینان کامل فرآیند درمان خود را ادامه
          دهید.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="closedrChavoshiNotAllowedModal"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>
  <site-modal ID="sessionsInformationModal" @closed="closeSessionsInformation">
    <template #header>
      <h6>
        <svg
          width="18px"
          height="18px"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          class="bi bi-info-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          ></path>
          <path
            d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
          ></path>
        </svg>
        راهنما
      </h6>
    </template>
    <template #body>
      <div>
        <p class="justified">
          <strong>راهنمای 1)</strong>
          اگر با روان‌درمانگر یا روانپزشک خاصی در مجموعه ارگانیک‌‌‌مایندد آشنایی
          دارید و مشتاق هستید که مشخصا از ایشان وقت خود را به ثبت رسانید، لطفا
          نام و نام خانوادگی وی را در محل مورد نظر وارد نمایید.
        </p>
        <p class="justified">
          <strong>راهنمای 2)</strong>
          اگر انتخاب درمانگر را به کلینیک واگذار کنید، با توجه به بازه زمانی
          مورد نظر شما، سه تن از پرتقاضاترین متخصصین کلینیک جهت انتخاب به شما
          معرفی خواهد شد.
        </p>
      </div>
    </template>
    <template #footer>
      <div class="m-auto">
        <button
          class="btn btn-sm rounded btn-blueSite"
          @click="closeSessionsInformation"
        >
          <i class="fi fi-box-checked"></i>
          تایید
        </button>
      </div>
    </template>
  </site-modal>
  <div>
    <toast-notification ref="notification" />
    <loading-spinner
      ref="spinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <!-- Filter Tab Start -->
    <div class="px-3 content">
      <div class="mb-3">
        <div>
          <p class="text-justified" v-if="hasSessionToReplace()">
            به منظور
            <span class="fw-bold text-danger-gradient blinkText"
              >جابجایی جلسه</span
            >
            شیوه برگزاری جلسه را انتخاب نمایید.
          </p>
        </div>
        <div class="mb-3 mt-1">
          <div class="accordion m-auto col-lg-5 col-md-6">
            <div class="accordion-item h-100">
              <div class="accordion-header p-2">
                <h6 class="m-0">
                  درمانگر و شیوه برگزاری جلسه را انتخاب نمایید:
                </h6>
              </div>
              <div class="accordion-collapse collapse show">
                <div class="accordion-body">
                  <div class="m-auto">
                    <template v-if="!hasSessionToReplace()">
                      <div class="form-check" v-if="myTherapistList.length > 0">
                        <input
                          class="form-check-input form-check-input-default"
                          type="radio"
                          value=""
                          id="myTherapistRadio"
                          name="therapistRadio"
                          :checked="therapistFilterStatus == 'myTherapist'"
                          @click="myTherapistRadioClick"
                        />
                        <label
                          class="form-check-label"
                          style="text-wrap: nowrap"
                          :class="isMobile ? 'fs-8 fw-bold' : ''"
                          for="myTherapistRadio"
                        >
                          درخواست ثبت جلسه با درمانگر قبلی را دارم
                          <span
                            v-if="therapistFilterStatus == 'myTherapist'"
                            class="text-danger"
                            style="position: relative; top: 0px; left: 0px"
                            >*</span
                          >
                        </label>
                      </div>
                      <div>
                        <searchable-input
                          :disabled="therapistFilterStatus != 'myTherapist'"
                          :style="
                            therapistFilterStatus != 'myTherapist'
                              ? 'display:none'
                              : 'display:block'
                          "
                          id="therapistSelect"
                          mode="single"
                          placeHolder="درمانگر خود را انتخاب نمایید"
                          errorText="انتخاب درمانگر الزامی است"
                          ref="myTherapistSelect"
                          :options="myTherapistList"
                          v-model:inputValue="entity.myTherapistID"
                          :canDeselect="false"
                          :searchable="false"
                          :canClear="false"
                          topTitle=""
                          inputTitle=""
                          topTitleClass="mb-1"
                          containerClass="my-1"
                        />
                      </div>
                      <div class="form-check my-3">
                        <input
                          class="form-check-input"
                          type="radio"
                          value=""
                          id="newTherapistRadio"
                          name="therapistRadio"
                          @click="newTherapistRadioClick"
                          :checked="therapistFilterStatus == 'newTherapist'"
                        />
                        <label
                          class="form-check-label col-10 col-md-11"
                          :class="isMobile ? 'fs-8 fw-bold' : ''"
                          style="text-wrap: nowrap"
                          for="newTherapistRadio"
                        >
                          مایلم درمانگری را که می‌شناسم انتخاب کنم
                          <span
                            v-if="therapistFilterStatus == 'newTherapist'"
                            class="text-danger position-absolute"
                            >*</span
                          >
                        </label>
                      </div>
                      <div>
                        <searchable-input
                          :disabled="therapistFilterStatus != 'newTherapist'"
                          :style="
                            therapistFilterStatus != 'newTherapist'
                              ? 'display:none'
                              : 'display:block'
                          "
                          mode="single"
                          placeHolder="نام خانوادگی درمانگر مورد نظر خود را تایپ کنید"
                          errorText="انتخاب درمانگر الزامی است"
                          ref="newTherapistSelect"
                          :loading="isLoadingNewTherapistList"
                          :options="newTherapistList"
                          v-model:inputValue="entity.newTherapistID"
                          @searchChange="newTherapistSearchKeyPress"
                          inputThem="purpleThem"
                          :noOptionsTextt="newTherapistNoOption"
                          :canDeselect="false"
                          :canClear="true"
                          topTitle=""
                          inputTitle=""
                          topTitleClass=""
                          containerClass="my-1"
                        />
                      </div>
                      <div class="form-check my-3">
                        <input
                          class="form-check-input"
                          type="radio"
                          value=""
                          id="dontcareTherapistRadio"
                          name="therapistRadio"
                          @click="dontcareTherapistRadioClick"
                          :checked="
                            therapistFilterStatus == 'dontCareTherapist'
                          "
                        />
                        <label
                          class="form-check-label col-10 col-md-11"
                          :class="isMobile ? 'fs-8 fw-bold' : ''"
                          for="dontcareTherapistRadio"
                        >
                          مایلم کلینیک درمانگری را برایم پیشنهاد دهد
                        </label>
                      </div>
                    </template>
                    <template v-else>
                      <h6>
                        نام درمانگر:
                        <b>{{
                          this.$store.getters.replacedSessionData.therapist
                        }}</b>
                      </h6>
                    </template>
                    <div class="form-check mb-2">
                      <searchable-input
                        :disabled="this.$store.getters.isOverseas == true"
                        :required="true"
                        id="therapistSelect"
                        mode="single"
                        placeHolder=""
                        errorText="انتخاب شیوه برگزاری الزامی است."
                        ref="sessionTypeSelect"
                        :options="sessionTypeList"
                        v-model:inputValue="entity.sessionTypeID"
                        :canDeselect="false"
                        :canClear="false"
                        :searchable="false"
                        topTitle="لطفا شیوه برگزاری را انتخاب نمایید."
                        inputTitle=""
                        :topTitleClass="
                          isMobile ? 'fs-8 fw-bold mb-1 me-4' : 'mb-1 me-4'
                        "
                        containerClass="my-1"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="text-md-start nextStepLeft">
        <button
          class="btn btn-sm btn-outline-danger m-2"
          v-if="hasSessionToReplace()"
          @click="showCancelReplacingModal()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-x-lg"
            viewBox="0 0 16 16"
          >
            <path
              fill-rule="evenodd"
              d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"
            ></path>
            <path
              fill-rule="evenodd"
              d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"
            ></path>
          </svg>
          لغو عملیات جابجایی
        </button>
        <button
          class="btn btn-sm btn-light-blue"
          @click="sessionPricesInfo()"
          :class="isMobile ? 'px-1' : ''"
        >
          <span> تعرفه </span>
        </button>
        <!-- <button
          class="btn btn-sm btn-warning"
          v-if="!hasSessionToReplace()"
          @click="openSessionsInformation()"
          :class="isMobile ? 'px-1' : ''"
        >
          <span> راهنما </span>
        </button> -->

        <a
          class="btn btn-sm btn-warning"
          href="https://www.aparat.com/v/guh7e55"
          :class="isMobile ? 'px-1' : ''"
          target="_blank"
        >
          <span>فیلم نحوه ثبت جلسه</span>
        </a>
        <button
          class="btn btn-sm btn-blueSite"
          :class="isMobile ? 'm-0 px-1 float-end' : ''"
          @click="nextTab()"
        >
          <svg
            width="18px"
            height="18px"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            class="bi bi-calendar-range"
            viewBox="0 0 16 16"
          >
            <svg
              width="18px"
              height="18px"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi bi-arrow-left"
              viewBox="0 0 16 16"
            >
              <path
                fill-rule="evenodd"
                d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"
              ></path>
            </svg>
          </svg>
          <span> گام بعدی </span>
        </button>
      </div>
      <div>
        <!-- <p class="text-justified">
          <i class="fi fi-round-info-full text-danger-gradient blinkText"></i>
          <template v-if="$store.getters.isOverseas">
            در صورت مواجهه با هر مشکلی به شماره
            <a href="tel:+98 903 130 9156" class="text-blueSite text-dashed"
              >00989031309156</a
            >
            در واتس‌اپ پیام بدهید.
          </template>
          <template v-else>
            در صورت مواجهه با هر مشکلی در فرآیند ثبت جلسه با شماره
            <a href="tel:۰۲۱۹۱۰۰۵۱۴۱" class="text-blueSite text-dashed"
              >۹۱۰۰۵۱۴۱-۰۲۱</a
            >
            تماس حاصل فرمایید.
          </template>
        </p> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
import LoadingSpinner from '../../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import SearchableInput from '../../../../../components/form/searchableInput/SearchableInput.vue';
import { Modal } from 'bootstrap';

export default {
  components: {
    LoadingSpinner,
    SearchableInput,
  },
  inject: [
    'nextStep',
    'hasSessionToReplace',
    'showCancelReplacingModal',
    'sessionPricesInfo',
  ],
  data() {
    return {
      newTherapistNoOption: '',
      sessionsInformationModal: new Object(),
      isMobile: isMobile,
      sessionTypeList: [],
      newTherapistList: [],
      myTherapistList: [],
      otherAbilityList: [],
      isLoadingNewTherapistList: false,
      therapistFilterStatus: 'myTherapist',
      entity: {
        myTherapistID: 0,
        newTherapistID: 0,
        sessionTypeID: 0,
      },
    };
  },
  watch: {
    tabState: async function (newValue) {
      if (newValue == 'reserve') {
        await this.getSessionReserveHeader();
      }
    },
    'entity.newTherapistID': function (newValue) {
      if (newValue == 37) {
        this.entity.newTherapistID = 0;
        this.newTherapistList = [];
        this.drChavoshiNotAllowedModal.show();
      }
    },
  },
  props: {
    entityObject: {
      therapistStatus: '',
      therapistID: null,
      sessionTypeID: 0,
    },
  },
  methods: {
    openSessionsInformation() {
      this.sessionsInformationModal.show();
    },
    closeSessionsInformation() {
      this.sessionsInformationModal.hide();
    },
    nextTab() {
      let isPass = true;
      if (!this.hasSessionToReplace()) {
        //اگر درمانگر خودم انتخاب شده بود مقدارش الزامی است
        if (
          this.therapistFilterStatus == 'myTherapist' &&
          this.entity.myTherapistID == 0
        ) {
          isPass = false;
          this.$refs.myTherapistSelect.showErrorMessage();
        }
        //اگر درمانگر جدید انتخاب شد مقدارش الزامی است
        if (
          this.therapistFilterStatus == 'newTherapist' &&
          (this.entity.newTherapistID == 0 ||
            this.entity.newTherapistID == null)
        ) {
          isPass = false;
          this.$refs.newTherapistSelect.showErrorMessage();
        }
      }
      //مقدار شیوه برگزاری الزامی است
      if (
        this.entity.sessionTypeID == 0 ||
        this.entity.sessionTypeID == undefined
      ) {
        isPass = false;
        this.$refs.sessionTypeSelect.showErrorMessage();
      }
      if (!isPass) return;
      this.nextStep(
        new Object({
          therapistID:
            this.therapistFilterStatus == 'myTherapist'
              ? this.entity.myTherapistID
              : this.therapistFilterStatus == 'newTherapist'
              ? this.entity.newTherapistID
              : null,
          therapistStatus: this.therapistFilterStatus,
          therapistList: this.newTherapistList,
          sessionTypeID: this.entity.sessionTypeID,
        }),
        'selectTherapist'
      );
    },
    resetFilteringEntity() {
      this.entity = new Object({
        myTherapistID: 0,
        newTherapistID: 0,
        sessionTypeID: this.$store.getters.isOverseas ? 2 : 0,
      });
    },
    newTherapistRadioClick() {
      this.therapistFilterStatus = 'newTherapist';
      if (this.$refs.myTherapistSelect != undefined)
        this.$refs.myTherapistSelect.hideErrorMessage();
      this.resetFilteringEntity();
    },
    myTherapistRadioClick() {
      this.therapistFilterStatus = 'myTherapist';
      if (this.$refs.newTherapistSelect != undefined)
        this.$refs.newTherapistSelect.hideErrorMessage();
      this.resetFilteringEntity();
    },
    dontcareTherapistRadioClick() {
      this.therapistFilterStatus = 'dontCareTherapist';
      if (this.$refs.newTherapistSelect != undefined)
        this.$refs.newTherapistSelect.hideErrorMessage();
      if (this.$refs.myTherapistSelect != undefined)
        this.$refs.myTherapistSelect.hideErrorMessage();
      this.resetFilteringEntity();
    },
    async getClientsTherapists() {
      let that = this;
      await axios
        .get(
          '/Basic/Therapist/GetClientsTherapists?personID=' +
            this.$store.getters.userPersonID
        )
        .then((response) => {
          that.clientTherapistList = response.data;

          if (response.data.length == 0) {
            this.newTherapistRadioClick();
          } else
            this.myTherapistList = response.data.map((m) => {
              return { id: m.id, label: m.title };
            });

          //اگر این کاربر جلسه ای نگرفته باشد، گزارش تخطی غیرفعال شود
          if (response.data.length == 0) {
            document
              .getElementById('reportTherapistFault')
              ?.classList.add('disabled');
          }
        })
        .catch(() => {
          that.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات درمانگران کاربر با خطا مواجه گردید.`,
          });
        });
    },
    async getAllFilteredTherapistList(searchInput) {
      this.isLoadingNewTherapistList = true;
      let that = this;
      await axios
        .get(
          '/Basic/Therapist/GetTherapistListBySearch?therapistName=' +
            searchInput
        )
        .then((response) => {
          if (response.data.length == 0)
            that.newTherapistNoOption = 'هیچ نتیجه برای انتخاب نیست';
          else that.newTherapistNoOption = '';
          that.newTherapistList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات درمانگران با خطا مواجه گردید.`,
          });
        })
        .finally(() => {
          that.isLoadingNewTherapistList = false;
        });
    },
    closedrChavoshiNotAllowedModal() {
      this.drChavoshiNotAllowedModal.hide();
      if (document.getElementsByClassName('multiselect-clear').length > 0)
        document.getElementsByClassName('multiselect-clear')[0].click();
    },
    async newTherapistSearchKeyPress(value) {
      if (value.trim().length >= 3) {
        await this.getAllFilteredTherapistList(value);
      }
    },
    async getSessionTypeList() {
      let that = this;
      await axios
        .get('Basic/SessionType/GetPublic')
        .then((response) => {
          that.sessionTypeList = response.data.map((m) => {
            return { id: m.id, label: m.title };
          });
        })
        .catch(() => {
          this.$refs.notification.show({
            type: 'error',
            title: `عملیات دریافت اطلاعات انواع برگزاری با خطا مواجه گردید.`,
          });
        });
    },
    registerVideoLink() {
      let url = '';
      if (this.isMobile) {
        if (this.$store.getters.isOverseas == true) {
          url = 'https://www.aparat.com/v/hbvs98b';
        } else {
          url = 'https://www.aparat.com/v/guh7e55';
        }
      } else {
        if (this.$store.getters.isOverseas == true) {
          url = 'https://www.aparat.com/v/qcd2143';
        } else {
          url = 'https://www.aparat.com/v/dermvcq';
        }
      }
      return url;
    },
  },
  async mounted() {
    this.sessionsInformationModal = new Modal(
      document.getElementById('sessionsInformationModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.drChavoshiNotAllowedModal = new Modal(
      document.getElementById('drChavoshiNotAllowedModal'),
      {
        keyboard: false,
        backdrop: 'static',
      }
    );
    this.$refs.spinner?.show();
    await this.getClientsTherapists();
    await this.getSessionTypeList();
    this.$refs.spinner?.hide();
    //اگر قبلا جلسه ای داشته است
    if (this.myTherapistList.length > 0)
      this.therapistFilterStatus = 'myTherapist';
    else this.therapistFilterStatus = 'newTherapist';
    switch (this.entityObject.therapistStatus) {
      case 'myTherapist':
        this.entity.myTherapistID = this.entityObject.therapistID;
        this.therapistFilterStatus = 'myTherapist';
        break;
      case 'newTherapist':
        this.newTherapistList = this.entityObject.therapistList;
        this.entity.newTherapistID = this.entityObject.therapistID;
        this.therapistFilterStatus = 'newTherapist';
        break;
      case 'dontCareTherapist':
        this.therapistFilterStatus = 'dontCareTherapist';
        break;
    }
    this.entity.sessionTypeID = this.entityObject.sessionTypeID;
    if (this.$store.getters.isOverseas) this.entity.sessionTypeID = 2;
  },
};
</script>
<style scoped>
.form-check-input[type='radio'] {
  float: right;
  margin-left: 5px;
  margin-right: 0;
}
.form-check-input:checked {
  background-color: #4c5e74 !important;
}
.accordion-header,
.accordion-button,
.collapsed {
  color: white;
  background-color: #4c5e74;
  border-radius: 5px 5px 0px 0px;
}
</style>
<style>
@media only screen and (max-width: 350px) {
  .content {
    min-height: 600px;
  }
}
@media only screen and (max-width: 576px) {
  .multiselect-placeholder {
    font-size: 12px !important;
  }
}
@media only screen and (min-width: 768px) {
  .multiselect-placeholder {
    font-size: 14px !important;
  }
}
</style>
